import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type ActionButtonProps = {
  onClick?: () => void;
  buttonClassName?: string;
  disabled?: boolean;
  icon: ReactNode;
  label: string;
};

/**
 * 공통 액션 버튼 Base 컴포넌트
 * - AiButton, WordReplaceButton의 기반이 되는 컴포넌트
 */
const ActionButtonBase = ({
  onClick,
  buttonClassName = 'ai_border',
  disabled,
  icon,
  label,
}: ActionButtonProps) => {
  const { t } = useTranslation();

  return (
    <StyledButton
      className={buttonClassName}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      {t(label)}
    </StyledButton>
  );
};

export default ActionButtonBase;

const StyledButton = styled.button`
  color: #c77ac4;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-sizing: content-box;
  height: 20px;
  padding: 6px;

  :disabled {
    color: var(--dk-text-disabled, #d1d8e2);
    cursor: auto;
    padding: 9px;
    border: 1px solid var(--dk-line, rgba(231, 233, 236, 1));
  }

  svg {
    display: block;
    width: 20px;
    height: 20px;
  }
`;
